import { render } from "./FattureAcquistoDetail.vue?vue&type=template&id=71c016a5"
import script from "./FattureAcquistoDetail.vue?vue&type=script&lang=js"
export * from "./FattureAcquistoDetail.vue?vue&type=script&lang=js"

import "./FattureAcquistoDetail.vue?vue&type=style&index=0&id=71c016a5&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__